import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberComparatorMax3, numberFilterParams, numberFilterParamsWithThreeDigits, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: getLocalizedString("month"),
            field: "Mes",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '1',
            field: "1",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '2',
            field: "2",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '3',
            field: "3",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '4',
            field: "4",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '5',
            field: "5",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '6',
            field: "6",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '7',
            field: "7",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '8',
            field: "8",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '9',
            field: "9",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '10',
            field: "10",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '11',
            field: "11",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '12',
            field: "12",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '13',
            field: "13",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '14',
            field: "14",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '15',
            field: "15",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '16',
            field: "16",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '17',
            field: "17",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '18',
            field: "18",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '19',
            field: "19",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '20',
            field: "20",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '21',
            field: "21",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '22',
            field: "22",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '23',
            field: "23",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '24',
            field: "24",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '25',
            field: "25",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '26',
            field: "26",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '27',
            field: "27",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '28',
            field: "28",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '29',
            field: "29",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '30',
            field: "30",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummaryMatrix],
        config: {
            headerName: '31',
            field: "31",
            filter: "agSetColumnFilter",
            width: 74,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("employeesProcessOrigen"),
            field: "Origen",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("initialYear"),
            field: "Año de inicio",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("initialPeriod"),
            field: "Período de inicio",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("dateFrom"),
            field: "Fecha desde",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("amountOfDays"),
            field: "Cantidad de días",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("dateEnd"),
            field: "Fecha hasta",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            field: "Fecha desde de aplicación",
            headerName: getLocalizedString("applicationStartDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            field: "Fecha hasta de aplicación",
            headerName: getLocalizedString("endDateOfApplication"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            field: "Tipo de incidencia",
            headerName: getLocalizedString("incidentType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            field: "Unidad",
            headerName: getLocalizedString("unit"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config:
        {
            headerName: getLocalizedString("timePerDay"),
            field: "Tiempo por día",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.issueSummary],
        config:
        {
            field: "Cantidad total",
            headerName: getLocalizedString("totalCount"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            field: "Referencia de tiempo",
            headerName: getLocalizedString("timeReference"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("positionEditorId"),
            field: "ID",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("fType"),
            field: "functionaryType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "contractType",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'workplace',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "workOrTask",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("department"),
            field: "department",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenter',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("function"),
            field: "function",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("group"),
            field: "Grupo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.issueSummary],
        config: {
            headerName: getLocalizedString("comment"),
            field: "Comentario",
            filter: "agTextColumnFilter",
        }
    },
]